import {
  Teleport as teleport_,
  TeleportProps,
  VNodeProps,
} from 'vue';

export default function useTeleport() {
  const Teleport = teleport_ as {
    new(): {
      $props: VNodeProps & TeleportProps
    }
  };

  return {
    Teleport,
  };
}
